import type { CurrencyCode } from "../CurrencyProvider";

export type GeoGuess = {
  country: string | null;
  currency: CurrencyCode | null;
};

const COUNTRY_TO_CURRENCY: Partial<Record<string, CurrencyCode>> = {
  US: "USD",
  EC: "USD",
  SV: "USD",
  PA: "USD",

  ES: "EUR",
  FR: "EUR",
  DE: "EUR",
  IT: "EUR",
  PT: "EUR",
  NL: "EUR",
  BE: "EUR",
  IE: "EUR",
  AT: "EUR",

  MX: "MXN",
  CA: "CAD",
  CH: "CHF",
  CU: "CUP",
};

function extractCountryFromNavigator(): string | null {
  try {
    const locale =
      navigator.languages?.[0] || navigator.language || navigator.language;
    if (!locale) return null;

    const parts = locale.split(/[-_]/);
    const region = parts[1]?.trim().toUpperCase();

    return region && region.length === 2 ? region : null;
  } catch {
    return null;
  }
}

export async function geoGuess(): Promise<GeoGuess> {
  const country = extractCountryFromNavigator();
  const currency = country ? (COUNTRY_TO_CURRENCY[country] ?? null) : null;

  return {
    country,
    currency,
  };
}
